/**
 * public/svg 下资源在浏览器中的绝对路径。
 * 与 src/pages/_app.js 中 `NEXT_PUBLIC_DEV ? "" : NEXT_PUBLIC_cdn + "/public"` 一致。
 *
 * 生产环境 next.config 的 assetPrefix 会把打包 CSS 放到 CDN；Less 里写的 `url(/svg/…)`
 * 常被解析为「CDN 主机 + /svg/…」，而静态文件实际在「CDN + /public/svg/…」或主站，导致线上 404、本地正常。
 * 在组件里用行内 style + 本函数生成的 URL，会按当前文档域加载，与开发环境一致。
 */
export function publicSvgUrl(filename) {
  const name = (filename || "").replace(/^\//, "");
  const rel = `/svg/${name}`;
  if (process.env.NEXT_PUBLIC_DEV) return rel;
  const cdn = process.env.NEXT_PUBLIC_cdn;
  if (cdn) return `${cdn}/public${rel}`;
  return rel;
}
